<template>
	<div class="page-wrapper">
		<nav class="navbar navbar-expand-lg navbar-light fixed-top navbar-center navbar-wrapper" id="navbar">

			<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarToggler" aria-controls="navbarToggler" aria-expanded="false" aria-label="Toggle navigation">
				<span class="navbar-toggler-icon" ></span>
			</button>
			<div class="collapse navbar-collapse menu-position" id="navbarToggler">

				<ul class="navbar-nav mt-2 mt-lg-0">
					<li class="nav-item">
						<a class="nav-link" v-scroll-to="'#home'" href="#" v-on:click="closeMenu">
							HOME
						</a>
					</li>
          <li class="nav-item">
            <a class="nav-link" v-scroll-to="'#about'" href="#body" @click="scrollIntoView">ABOUT</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" v-scroll-to="'#branch'" href="#branches" v-on:click="closeMenu">BRANCHES</a>
          </li>
<!--					<li class="nav-item">-->
<!--						<a class="nav-link" v-scroll-to="'#openingTime'" href="#openingTime" v-on:click="closeMenu">OPENING HOURS</a>-->
<!--					</li>-->
<!--					<li class="nav-item">-->
<!--						<a class="nav-link" v-scroll-to="'#menu'" href="#menu" v-on:click="closeMenu">MENU</a>-->
<!--					</li>-->
<!--          <li class="nav-item">-->
<!--            <a class="nav-link" v-scroll-to="'#gallery'" href="#" v-on:click="closeMenu">GALLERY</a>-->
<!--          </li>-->
<!--					<li class="nav-item">-->
<!--						<a class="nav-link" v-scroll-to="'#book'" href="#" v-on:click="closeMenu">BOOK A TABLE</a>-->
<!--					</li>-->

<!--					<li class="nav-item" v-if="configs.length > 1">-->
<!--						<a class="nav-link" v-on:click="moveToLanding()">BRANCHES</a>-->
<!--					</li>-->
				</ul>
			</div>

		</nav>
    <div style="position: fixed; width: 100%; height: 50px; z-index: 2" id="topbar" class="trasnparent-background">
      <img src="https://storage.googleapis.com/menus-275719.appspot.com/webs/donburi/logo.png" id="logo" class="big-logo" style="position: fixed; z-index: 3" data-toggle="collapse" data-target="#navbarToggler" aria-controls="navbarToggler" aria-expanded="false" aria-label="Toggle navigation"/>
    </div>

<!--		<div class="section main-background" v-if="config != false" id="home" v-bind:style="{backgroundImage: 'url(' + currentImage + ')'}">-->
		<div class="section main-background" style="min-height:300px;" id="home">

      <div class="logo-box text-left" style="">

        <h1 style="font-weight:bold; margin: 0px; letter-spacing: 1px; color: rgb(191, 191, 191);transform: scaleX(0.7);transform-origin:left;">HUNGRY?</h1>
        <h2 style="color:white; font-size:3rem; letter-spacing: 0px; font-weight: bold;transform: scaleX(0.7);transform-origin:left;">GREAT FOOD TAKEAWAY</h2>
			</div>
		</div>
    <div class="container">
      <div class="row rep-icon">
        <div class="col-6 col-md-3">
          <span><i class="far fa-clock"></i> 7 DAYS TAKEAWAY</span>
        </div>
        <div class="col-6 col-md-3">
          <span><i class="fas fa-hamburger"></i> OVER 25 DISHES</span>
        </div>
        <div class="col-6 col-md-3">
          <span><i class="fas fa-mobile-alt"></i> ONLINE ORDER</span>
        </div>
        <div class="col-6 col-md-3">
          <span><i class="fas fa-car-alt"></i> FAST PICKUP</span>
        </div>
      </div>
    </div>


    <div class="container" id="branch">
      <div class="anchor"></div>
      <div class="row">
        <div class="col-12 text-center">
          <h2 style="text-align:center; font-size:2rem; letter-spacing: 0px; font-weight: bold;transform: scaleX(0.7);transform-origin:center;">DONBURI BRANCHES</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-6 col-lg-4" v-for="branch in branches">
          <div class="branch-card">
            <div class="branch-card-image" v-bind:style="{backgroundImage : 'url(' + branch.setting.image_url + ')'}">

              <div v-if="branch.distance > 0" class="distance-box">{{(branch.distance).toFixed(1)}} miles</div>
            </div>
            <div class="branch-body">
              <div class="title">
              {{branch.setting.branchTitle}}

                <template v-if="branch.start_date > today">
                  <br>Open on {{branch.start_date}}
                </template>
              </div>
              <div class="info">
                {{branch.setting.address}}
                <br>
                {{branch.setting.contact}}
              </div>
              <div class="links">

                <div style="width: 25%;" class="text-center"><a :href="'tel:'+branch.setting.contact"><div style="width: 70px; height: 50px; line-height: 50px; text-align: center; font-size: 30px;"><i class="fas fa-phone"></i></div></a></div>

                <div style="width: 25%;" class="text-center"><a :href="'http://maps.google.com/?q='+branch.setting.title + ',' + branch.setting.address"><div style="width: 70px; height: 50px; line-height: 50px; text-align: center; font-size: 30px;"><i class="fas fa-map-marker-alt"></i></div></a></div>

                <div style="width: 25%; position:relative;" class="text-center">
                <template v-if="branch.setting.url.startsWith('https://www.ubereats.com/')">
                  <a :href="branch.setting.url"><img style="width: 50px; height: 50px; border-radius: 25px; box-shadow: 3px 3px 3px grey;" src="../assets/img/uber-logo.png"/></a>
                </template>
                </div>
                <div style="width: 25%; position:relative;" class="text-center">
                <template v-if="branch.setting.orderUrl != null && branch.setting.orderUrl.startsWith('https://')">
                  <div style="position:absolute; padding-left:10px; padding-right:10px; left:50%; transform: translateX(-50%); height: 50px; line-height: 50px; margin:auto; font-size: 15px; background-color: black; border-radius: 25px; box-shadow: 3px 3px 3px grey;">
                  <a :href="branch.setting.orderUrl" style="color:white; font-weight: bold;" >
<!--                    <img style="width: 70px; height: 70px;" src="https://storage.googleapis.com/menus-275719.appspot.com/logos/smtm-logo.png"/>-->
                    Order
                  </a>
                  </div>
                </template>
                </div>

              </div>
            </div>
          </div>




        </div>
        <div class="col-12 col-sm-6 col-lg-4">
          <div class="branch-card">
            <div class="branch-card-image" style="background-color:grey; background-size: contain; background-image: url('https://storage.googleapis.com/menus-275719.appspot.com/webs/donburi/logo.png');">

              <!--              <div v-if="branch.distance > 0" class="distance-box">{{(branch.distance).toFixed(1)}} miles</div>-->
            </div>
            <div class="branch-body">
              <div class="title">
                New Branch Coming Soon
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="container-fluid text-center" id="openingTime" style="display: none;">
      <div class="anchor" ></div>
      <div class="row">
        <div class="container">
          <div class="col-12 text-center content-wrap">
            <div class="content-box">
              <h2>
                <span><img class="logo-section-image" v-bind:src="webSetting.icon"></span>
                Opening Time
              </h2>



            </div>
          </div>

        </div>
        <div class="col-12 text-center">
          <table class="table" style="max-width: 500px; margin:auto;">

            <tr v-for="(day, di) in openingTime">
              <td>{{day.dayString}}</td>
              <td>{{day.open==true?'Open':'Close'}}</td>
              <td>
                <template v-if="day.open == true && day.times != undefined && day.times.length > 0">
                  <div v-for="time in day.times">{{time.from}} ~ {{time.to}}</div>
                </template>
              </td>

            </tr>
          </table>
        </div>
      </div>
    </div>


		<div class="container" id="about">
			<div class="anchor" ></div>
			<div class="row post-row">
        <div class="col-12 col-md-6 post">
          <div class="post-title">THE BEST FOOD FOR OVER 7 YEARS</div>

          <div class="post-sub-title">AUTHENTIC KOREAN AND JAPANESE FOOD</div>
          <div class="post-divider"><div/></div>
          <div class="post-content">
            <p>SIMPLE BUT TASTY KOREAN AND JAPANESE FOOD.</p>
            <p>You can choose between donburi (Japanese rice bowl dish), bibimbap (Korean mixed rice) or hirata buns (Japanese steamed buns). All come with a variety of meat or vegetables.</p>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="post-img" style="border:1px solid black; background-image: url('https://storage.googleapis.com/menus-275719.appspot.com/webs/donburi/about-01.jpg');"></div>

        </div>
      </div>

      <div class="row post-row">
        <div class="col-12 col-md-6">
          <div class="post-img" style="border:1px solid black; background-image: url('https://storage.googleapis.com/menus-275719.appspot.com/webs/donburi/about-02.jpg');"></div>

        </div>
        <div class="col-12 col-md-6 post">
          <div class="post-title">Incredible, Unique Donburi</div>

          <div class="post-sub-title">DELICIOUSLY JAPANESE DISH</div>
          <div class="post-divider"><div/></div>
          <div class="post-content">
            <p>Donburi (丼, literally “bowl”, also abbreviated to “don” as a suffix, less commonly spelled “domburi”) is a Japanese “rice bowl dish” consisting of fish, meat, vegetables or other ingredients simmered together and served over rice. Donburi meals are usually served in oversized rice bowls which are also called donburi. Donburi is sometimes called “sweetened” or “savory stews on rice”.

            </p>
          </div>
        </div>

      </div>


      <div class="row post-row">
        <div class="col-12 col-md-6 post">
          <div class="post-title">Fresh and Healthy Bibimbap</div>

          <div class="post-sub-title">KOREAN MADE WITH ORIGINAL RECIPE</div>
          <div class="post-divider"><div/></div>
          <div class="post-content">
            <p>Bibimbap is a large bowl of rice topped with an array of individually prepared vegetables and meat and served with a gochujang sauce. Once you mix the vegetables, meat, and rice with a spicy gochujang sauce, you can enjoy a delicious harmony of different flavours and textures with every bite. It’s one of our absolute loved Korean comfort foods!</p>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="post-img" style="border:1px solid black; background-image: url('https://storage.googleapis.com/menus-275719.appspot.com/webs/donburi/about-03.jpg');"></div>

        </div>
      </div>
		</div>



		<div class="container-fluid text-center" id="menu" style="display: none;">
			<div class="row">
				<div class="container no-padding">
					<div class="col-12 text-center content-wrap">
						<div class="content-box">

              <h2><img class="logo-section-image" v-bind:src="webSetting.icon">MENU</h2>
						</div>
					</div>
				</div>
        <div class="container">
          <div class="row">
            <div class="col-12">
              <a v-bind:href="'https://storage.googleapis.com/menus-275719.appspot.com/webs/soya/soya_menu_200926-2.pdf'" target="_blank"><div class="btn btn-primary ss-btn">Menu</div></a>
              <a v-bind:href="'https://storage.googleapis.com/menus-275719.appspot.com/webs/soya/soya_lunch_200222-3.pdf'" target="_blank"><div class="btn btn-primary ss-btn">Lunch</div></a>
            </div>
          </div>
        </div>
			</div>
		</div>


		<div class="container-fluid text-center" id="gallery" style="display: none;">
			<div class="row">
				<div class="container no-padding">
					<div class="col-12 text-center content-wrap">
						<div class="content-box">
							<h2>
								<img class="logo-section-image" v-bind:src="webSetting.icon">
								GALLERY
							</h2>
							<div class="container">
								<ul class="gallery">
									<li v-for="(item, index) in webSetting.menuImages" class="gallery-item col-4 col-sm-3">
										<a v-bind:href="item"  v-bind:style="{ backgroundImage: 'url(' + item + ')' }"></a>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>




		<div class="container-fluid text-center" id="book">
			<div class="row" v-if="config != false">
				<div class="container no-padding">
					<div class="col-12 text-center content-wrap">
						<div class="content-box">
							<h2>
								<img class="logo-section-image" v-bind:src="webSetting.icon">
								BOOKING
							</h2>
							<div class="container content-frame">
								<div class="row">
									<div class="col-12 col-sm-6 text-left">
										<i class="fas fa-map-marker"></i>
                    <p v-html="config.address.replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
										<i class="fas fa-phone"></i><br>
                    <p><a :href="'tel:' + config.contact">{{config.contact}}</a></p>

										<hr>

									</div>
									<div class="col-12 col-sm-6" style="display: none;">
										<div class="container text-left">
											<div class="row form-group">
												<div class="col-12 col-sm-3">
													Name
												</div>
												<div class="col-12 col-sm-9">
													<input id="form-name" type="text" class="form-control col-12" name="your-name" aria-required="true" aria-invalid="true" placeholder="Your Name" v-model="formName"/>
												</div>
												<span id="form-name-alert"role="alert" class="alert hide">The field is required</span>
											</div>
											<div class="row form-group">
												<div class="col-12 col-sm-3">
													Contact
												</div>
												<div class="col-12 col-sm-9">
													<input id="form-phone" type="text" class="form-control col-12" name="your-phone" aria-required="true" aria-invalid="true" placeholder="Phone Number" v-model="formPhone"/>
												</div>
												<span id="form-contact-alert"role="alert" class="alert hide">The field is required</span>
											</div>
											<div class="row form-group">
												<div class="col-12 col-sm-3">
													Email
												</div>
												<div class="col-12 col-sm-9">
													<input id="form-email" type="text" class="form-control col-12" name="your-email" aria-required="true" aria-invalid="true" placeholder="Your Email" v-model="formEmail"/>
												</div>
												<span id="form-email-alert"role="alert" class="alert hide">The field is required</span>
											</div>
											<div class="row form-group">
												<div class="col-12 col-sm-3">
													Date
												</div>
												<div class="col-12 col-sm-9">
													<input type="date" class="form-control col-12" v-model="formDate" @change="onBookingDateSelected()"/>
												</div>
											</div>
											<div class="row form-group">
												<div class="col-12 col-sm-3">
													For
												</div>
												<div class="col-12 col-sm-9">
													<select class="form-control" v-model="formHeadCount">
														<option v-for="i in (2, config.bookingMax)" :value="i">{{i}}</option>
													</select>
												</div>
											</div>
											<div class="row form-group">
												<div class="col-12 col-sm-3">
													Time
												</div>
												<div class="col-12 col-sm-9">
													<select class="form-control" v-model="formTime">
														<option v-for="(slot, index) in bookingTimeSlots" :value="slot">{{slot}}</option>
													</select>
												</div>
											</div>
											<div class="form-group  text-left">
												<textarea id="form-message" class="form-control col-12" name="your-text" aria-required="true" aria-invalid="true" placeholder="Your Message" rows="5" v-model="formMessage"></textarea>
												<span id="form-message-alert"role="alert" class="alert hide">The field is required</span>
											</div>
											<div class="form-group text-left">
												<button type="button" class="btn btn-primary" v-on:click="sendForm">Make Reservation</button>
											</div>
										</div>
									</div>
									<div class="col-12 section-map">

										<div class="map-container" id="mapName">
											<iframe :src="webSetting.googleMap" width="100%" height="100%" frameborder="0" style="border:0" allowfullscreen></iframe>
											<gmap-map
										      :center="center"
										      :zoom="15"
										      style="width:100%; height:100%;display:none;">
										    </gmap-map>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    <div class="container-fluid foot-background">
      <div class="row">
        <div class="col-12">
          <img src="https://storage.googleapis.com/menus-275719.appspot.com/webs/donburi/logo.png">
        </div>
        <div class="col-12" style="color:white; margin-top:40px;">
          <a href="https://www.facebook.com/donburi.co.uk/" target="_blank"><span class="footer-icon"><img src="https://storage.googleapis.com/menus-275719.appspot.com/webs/icon_facebook.png"/></span></a>
          <a href="https://www.instagram.com/donburi.co/?hl=en" target="_blank"><span class="footer-icon"><img src="https://storage.googleapis.com/menus-275719.appspot.com/webs/icon_insta.png"/></span></a>
          <span class="footer-icon"><img src="https://storage.googleapis.com/menus-275719.appspot.com/webs/icon_mail.png"/></span>
        </div>
        <div class="col-12" style="font-size:12px; color: #fcdc31; font-weight: bold;margin-top:80px;">
          © Copyright 2012 - 2021 | Donburi & Co. All Rights Reserved
        </div>
      </div>
    </div>
    <div class="popup-background" v-if="showPopMessage == true" v-on:click="closePopup">
      <div class="popup-container">
          <img width="100%" style="max-width: 500px;" src="https://storage.googleapis.com/menus-275719.appspot.com/webs/soya/christmas-bg-2.jpg"/>

      </div>
    </div>
		<div class="progressView" v-if="showProgress==true">

			<div class="center-container container">
				<div class="row">
					<div class="col-4">
						<div class="loader"></div>
					</div>
					<div class="col-8">
						<div class="center-container text-left">
							{{progressMessage}}
						</div>
					</div>
				</div>
			</div>
		</div>
		<v-dialog/>
	</div>
</template>

<script>
  import {getBranches, getMerchant} from "../api/borium";

require('@/assets/css/styles.css')

import axios from 'axios';

export default {
  name: 'Home',
  data () {
    return {
		center: { lat: 51.4333997, lng:-0.5141324},

		msg: 'Welcome to Sushi Nara Staines',
        images:[],
        currentNumber:0,
        timer:null,
		formName:'',
		formEmail:'',
		formPhone:'',
		formDate:'',
		formHeadCount:2,
		formTime:'',
		formSubject:'',
		formMessage:'',

		formPhoneNumber:'',
		bookingTimeSlots:[],
		branch: 'Guildford',
		configs: false,
		config: false,
		otherConfig: false,
      webSetting:false,

		showProgress:false,
		progressMessage:'Please Wait',
      openingTime:[],
      showPopMessage: false,
      pos:0,
      branches:[],
      position: {
        lat:0,
        lng:0,
      },
      today:'',
    }




  },
 	created: function() {
 		//this.branch = "Soya Weybridge";
    this.$data.today = this.getDateForm(new Date());
    console.log("today " + this.$data.today);
 		this.getConfiguration();
    window.addEventListener('scroll', this.handleScroll);
 	},
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted: function() {
	/*
		const element = document.getElementById(this.mapName)

		const options = {
			zoom: 14,
			center: new google.maps.LatLng(51.501527,-0.1921837)
		}
		const map = new google.maps.Map(element, options);
		var infoWindow = new google.maps.InfoWindow;
		*/
	},
    computed: {
        currentImage: function() {
            if(this.$data.webSetting == false || this.$data.webSetting.imageUrls == undefined) {
              return '';
            }
            return this.$data.webSetting.imageUrls[Math.abs(this.currentNumber) % this.$data.webSetting.imageUrls.length];
        }
    },
  	methods: {
        closePopup: function() {
            this.$data.showPopMessage = false;
        },
        closeMenu: function() {
            let nav = document.getElementById("navbarToggler");
            if(nav != null) {
              nav.classList.remove("show");
            }
        },
        startRotation: function() {
            this.timer = setInterval(this.next, 3000);
        },

        stopRotation: function() {
            clearTimeout(this.timer);
            this.timer = null;
        },
        next: function() {
            this.currentNumber += 1
        },
        prev: function() {
            this.currentNumber -= 1
        },
  		showProgressView: function(msg) {
	  		console.log("showProgress");
	  		this.$data.progressMessage = msg;
	  		this.$data.showProgress = true;
	  	},
	  	dismissProgressView: function() {
	  		console.log("stopProgress");
	  		this.$data.showProgressLoading = false;
	  		this.$data.showProgress = false;
	  	},
	  	changeConfig: function(branch) {
	  		this.$data.otherConfig = this.$data.config;
	  		this.$data.config = this.$data.configs[branch];


	  		this.$data.branch = this.$data.config.branch;

	  		console.log("Other branch is now " + this.$data.otherConfig.branch);
	  	},
      getDateForm: function(time) {
          var dd = String(this.appendLeadingZeroes(time.getDate()));
          var mm = String(this.appendLeadingZeroes(time.getMonth() + 1)); //January is 0!
          var yyyy = time.getFullYear();
          return yyyy + '-' + mm + '-' + dd;
      },
      getLocalDayForm: function(time) {
          var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
          return months[time.getMonth()] + ' ' + time.getDate();
      },
  		getConfiguration: function() {
        let self = this;
        getBranches(60)
        .then(function(data) {
          // console.log("success");
          // console.log(JSON.stringify(data));
          if(data.success == true) {
            for(let i = 0 ; i < data.list.length ; i++) {
              data.list[i].distance = 0;
            }
            self.$data.branches = data.list;
            // console.log(self.$data.branches);

            self.getCurrentLocation();

          }
        })
        .catch(function(err) {
          // console.log(err);
          // if(err.response != undefined) {
          //   console.log(err.response);
          // }
        })
  		},
  		initialiseForm: function() {
  			this.$data.formName = '';
  			this.$data.formEmail = '';
  			this.$data.formSubject = '';
  			this.$data.formMessage = '';
  			this.$data.formDate = '';
        this.$data.formTime = '';
        this.$data.formPhone = '';
        this.$data.formHeadCount = '';
  		},
  		getBookingDayKey: function(day) {
  			if(day == 0) {
  				return 'bookingSun';
  			} else if(day == 1) {
  				return 'bookingMon';
  			} else if(day == 2) {
  				return 'bookingTue';
  			} else if(day == 3) {
  				return 'bookingWed';
  			} else if(day == 4) {
  				return 'bookingThu';
  			} else if(day == 5) {
  				return 'bookingFri';
  			} else if(day == 6) {
  				return 'bookingSat';
  			}
  			return false;
  		},
  		appendLeadingZeroes: function(n){
			if(n <= 9){
				return "0" + n;
			}
			return n
		},
  		onBookingDateSelected: function() {
  			this.$data.bookingTimeSlots = [];
  			var selectedDate = this.$data.formDate;
  			if(selectedDate.length == 0) {
  				return;
  			}

  			var d = new Date(selectedDate);
  			console.log("Selected day is " + this.getBookingDayKey(d.getDay()));
  			var bookingTimeRange = this.$data.config[this.getBookingDayKey(d.getDay())];
  			if(bookingTimeRange.length == 0) {
  				// console.log("Cannot choose");
  				this.$modal.show('dialog',{
            title:"CANNOT BOOK",
            text: "Please choose different date"
          })
  				this.$data.formDate = '';
  				return;
  			}
  			if(this.$data.config.holidays != undefined && this.$data.config.holidays.length > 0) {
            for (var i = 0; i < this.$data.config.holidays.length; i++) {
                if(this.$data.config.holidays[i].type === 'period') {
                  if(selectedDate >= this.getDateForm(this.$data.config.holidays[i].from) && selectedDate <= this.getDateForm(this.$data.config.holidays[i].to)) {
                    this.$modal.show('dialog',{
                      title:this.$data.config.holidays[i].text,
                      text: this.$data.config.holidays[i].description.length>0?this.$data.config.holidays[i].description:"Please choose different date",
                    })
                    this.$data.formDate = '';
                    return;
                  }

                }
                if(this.$data.config.holidays[i].type != 'full') {
                    continue;
                }
                if(this.$data.config.holidays[i].date == selectedDate) {
                    this.$modal.show('dialog',{
                        title:"Holiday",
                        text: "Please choose different date"
                    })
                    this.$data.formDate = '';
                }
            }
        }
          var isToday = false;
          var currentHour = 0;
  			var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
          var limitTime = new Date(today.getTime() + 60*60*1000);

        today = yyyy + '-' + mm + '-' + dd;



        if(selectedDate == today) {
            console.log("IT is today");
            isToday = true;
            currentHour = today
        }

  			var timeRanges = bookingTimeRange.split(',');

  			console.log("interval " + this.$data.config.bookingInterval);
  			console.log("timeRange " + timeRanges + " arary " + timeRanges.length);
  			let holiday = false;
        if(this.$data.config.holidays != undefined && this.$data.config.holidays.length > 0) {
            for (var i = 0; i < this.$data.config.holidays.length; i++) {
                if(this.$data.config.holidays[i].date == selectedDate) {
                    holiday = this.$data.config.holidays[i];
                    break;
                }
            }
        }
  			for(var i = 0 ; i < timeRanges.length ; i++) {
  				var range = timeRanges[i];
  				console.log("Range " + range);
  				var timeRange = range.split('-');
  				//var continue = true;
  				var time = timeRange[0];
  				console.log("H " + time.substr(0,2));
  				console.log("M " + time.substr(2));
  				d.setHours(parseInt(time.substr(0,2)));
  				d.setMinutes(parseInt(time.substr(2)));

  				var endTime = new Date(selectedDate);
  				endTime.setHours(parseInt(timeRange[1].substr(0,2)));
  				endTime.setMinutes(parseInt(timeRange[1].substr(2)));
  				while(d < endTime) {
  					console.log(d.getHours() + ' ' + d.getMinutes());
  					var timeSlot = this.appendLeadingZeroes(d.getHours()) + ":" + this.appendLeadingZeroes(d.getMinutes())

            if(d > limitTime) {
                if(holiday != false && d > holiday.from && d < holiday.to) {

                } else {
                    this.$data.bookingTimeSlots.push(timeSlot);
                }
            }

  					d.setMinutes(d.getMinutes() + parseInt(this.$data.config.bookingInterval));

  				}
  			}

  		},
        validateEmail: function(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
		sendForm: function() {
			console.log("sendForm");
			this.showProgressView("Checking Request");
			var verified = true;
			var message = '';
			if(this.$data.formName.length == 0) {
				$("#form-name-alert").removeClass("hide");
				verified = false;
				message += 'Name is required<br>';
			} else {
				$("#form-name-alert").addClass("hide");
			}
			if(this.$data.formEmail.length == 0 || !this.validateEmail(this.$data.formEmail)) {
				$("#form-email-alert").removeClass("hide");
				verified = false;
				message += 'Email is required<br>';
			} else {
				$("#form-email-alert").addClass("hide");
			}
			/*
			if(this.$data.formSubject.length == 0) {
				$("#form-subject-alert").removeClass("hide");
				verified = false;
			} else {
				$("#form-subject-alert").addClass("hide");
			}
			if(this.$data.formMessage.length == 0) {
				$("#form-message-alert").removeClass("hide");
				verified = false;
			} else {
				$("#form-message-alert").addClass("hide");
			}
			*/
			if(this.$data.formDate.length == 0) {
				message += 'Date is required<br>';
				verified = false;
			}
			if(this.$data.formTime.length == 0) {
				message += 'Time is required<br>';
				verified = false;
			}
			if(this.$data.formPhone.length < 10) {
				message += 'Contact is required<br>';
				verified = false;
			}
			if(this.$data.formHeadCount.length == 0) {
				message += 'Number of people is required<br>';
				verified = false;
			}
			var self = this;
			if(verified == false) {
				this.dismissProgressView();
				this.$modal.show('dialog', {
						title: 'SORRY',
						text: message,
						buttons:[
							{
								title:'CLOSE',
								handler:()=>{self.$modal.hide('dialog');}
							},
						]

					});
				return;
			}

			this.showProgressView("Submitting reservation request");
			var message = this.nl2br(this.$data.formMessage);
			var args = 'name=' + this.$data.formName + '&email=' + this.$data.formEmail + '&subject=' + this.$data.formSubject + '&message=' + message;
			args += '&bookingDate=' + this.$data.formDate;
			args += '&bookingTime=' + this.$data.formTime;
			args += '&phone=' + this.$data.formPhone;
			args += '&headCount=' + this.$data.formHeadCount;

			axios.get(process.env.ROOT_API + '?sheet=' + this.$data.branch + '&type=booking&' +args )
			.then(response => {
				self.dismissProgressView();
				console.log(response);
				var data = response.data;
				if(data.result == 'success') {
					self.$modal.show('dialog', {
						title: 'SUSHI NARA',
						text: 'Your Booking Request has been successfully submitted. We will contact you as soon as possible. Thank you',
						buttons:[
							{
								title:'CLOSE',
								handler:()=>{self.$modal.hide('dialog');}
							},

						]

					});
					self.initialiseForm();
				} else {
					self.$modal.show('dialog', {
						title: 'SORRY',
						text: 'Something went wrong. Please try again in a moment. Or contact us by phone.',
						buttons:[
							{
								title:'CLOSE',
								handler:()=>{self.$modal.hide('dialog');}
							},
						]

					});
				}
			})
			.catch(error=>{

				console.log(error);
			});

		},
		nl2br: function(str) {
			if(str == undefined) {
				return "";
			}
			var str = str.split('\n');
			var output = "";
			for(var i = 0 ; i < str.length ; i++) {
				if(i > 0) {
					output += '<br>';
				}
				output +=  str[i];
			}
			return output;
		},
		scrollIntoView(evt) {
          this.closeMenu();
	        evt.preventDefault()
	        const href = evt.target.getAttribute('href')
	        const el = href ? document.querySelector(href) : null
	        if (el) {
	          this.$refs.content.scrollTop = el.offsetTop
	        }
	    },
	    moveToLanding: function() {
	    	this.$router.push('/');
	    },
      handleScroll(event) {
        // console.log(this.$data.pos + " " + window.scrollY);
        if(this.$data.pos > 100 && window.scrollY <= 100) {
          // console.log("make large");
          if($("#logo").hasClass("smaller-logo") == true) {
            // console.log("make large remove smaller logo");
            $("#logo").removeClass("smaller-logo")
          }
        } else if(this.$data.pos < 100 && window.scrollY >= 100) {

          // console.log("make smaller");
          if($("#logo").hasClass("smaller-logo") == false) {
            // console.log("make large add smaller logo");
            $("#logo").addClass("smaller-logo")
          }
        }


        if(this.$data.pos > 300 && window.scrollY <= 300) {
          // console.log("make large");
          if($("#topbar").hasClass("top-bar-background") == true) {
            // console.log("make large remove smaller logo");
            $("#topbar").removeClass("top-bar-background")
          }
        } else if(this.$data.pos < 300 && window.scrollY >= 300) {

          // console.log("make smaller");
          if($("#topbar").hasClass("top-bar-background") == false) {
            // console.log("make large add smaller logo");
            $("#topbar").addClass("top-bar-background")
          }
        }
        this.$data.pos = window.scrollY;
        // if()
        // let ncmSelectorTop = 180 - event.srcElement.scrollTop;
        // // console.log(ncmSelectorTop);
        // if (ncmSelectorTop < 0) {
        //   ncmSelectorTop = 0;
        // }
        // document.getElementById("ncm-selector").style.top = ncmSelectorTop + 'px';
      },
      getCurrentLocation: function() {
        let self = this;

        if(navigator.geolocation) {
          console.log("getting location");
          navigator.geolocation.getCurrentPosition(position => {
            console.log("position");
            console.log(position);
            self.$data.position.lat = position.coords.latitude;
            self.$data.position.lng = position.coords.longitude;
            // self.getRestaurantList();
            self.onPositionAcquired();
          }, error => {

          });
        } else {
          // console.log("No geolocation");

        }
      },
      onPositionAcquired: function() {
          console.log("Position Acquired");
          if(this.$data.branches.length == 0) {
            return;
          }
          if(this.$data.position.lat !== 0 && this.$data.position.lng !== 0) {
            for(let i = 0 ; i < this.$data.branches.length ; i++) {
              if(this.$data.branches[i].setting !== undefined && this.$data.branches[i].setting !== null) {
                this.$data.branches[i].distance = this.calculateDistance(this.$data.position.lat, this.$data.position.lng, this.$data.branches[i].setting.lat, this.$data.branches[i].setting.lng, 'M')
              }
            }
          }
        this.$data.branches.sort(function(a, b) {
          return a.distance > b.distance ? 1 : -1;
        })
      },
      calculateDistance: function(lat1, lon1, lat2, lon2, unit) {
        var radlat1 = Math.PI * lat1/180
        var radlat2 = Math.PI * lat2/180
        var radlon1 = Math.PI * lon1/180
        var radlon2 = Math.PI * lon2/180
        var theta = lon1-lon2
        var radtheta = Math.PI * theta/180
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        dist = Math.acos(dist)
        dist = dist * 180/Math.PI
        dist = dist * 60 * 1.1515
        if (unit=="K") { dist = dist * 1.609344 }
        if (unit=="N") { dist = dist * 0.8684 }
        return dist
      },
	}

}
</script>
<style>
  a {
    color: black;
  }
  .section {
    width:100%;
    position: relative;
  }
  .main-slide-container {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .fade-enter-active, .fade-leave-active {
    transition: all 0.8s ease;
    overflow: hidden;
    visibility: visible;
    opacity: 1;
    position: absolute;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
    visibility: hidden;
  }
  .logo-section-image {
    height: 1.9em;
  }
  .logo-box {
    position: absolute;
    bottom:0px;
    left:0;
  }
  .rep-icon {
    /*font-family: Barlow;*/
    letter-spacing: 1px;
    font-weight: 800;
    padding-top:30px;
    padding-bottom:30px;
  }
  .rep-icon > div {
    padding-top:20px;
    padding-bottom: 20px;
  }
  .navbar-light .navbar-brand {
    color: white;
  }
  .footer-icon {
    padding: 30px;
  }

  .big-logo {
    width: 150px;
    height: 150px;
    left: 10px;
    top: 10px;
    transition: all 0.3s ease-in-out;
  }
  .smaller-logo {
    width: 50px;
    height: 50px;
    left: 10px;
    top: 0px;
  }
  @media (max-width: 420px) {
    .big-logo {
      left: 20px;
      top: 20px;
      width: 100px;
      height: 100px;
    }
    .smaller-logo {
      width: 50px;
      height: 50px;
      left: calc(100% - 70px);

      top: 0px;
    }
  }
  /*@media (max-width: 420px) {*/
  /*  .smaller-logo {*/
  /*    display: none;*/
  /*  }*/
  /*}*/
  .trasnparent-background {
    background-color: transparent;
    transition: all 0.3s ease-in-out;
  }
  .top-bar-background {

  }

  @media (min-width: 421px) {
    .menu-position {
      float: right;
    }
  }
  @media (max-width: 420px) {
    .top-bar-background {
      background-color: #f3f3f3;
      background-image: linear-gradient(to right, #f3f3f3, black);
    }
    .navbar-collapse {
      width: 100%;
      background-color: #f3f3f3;
    }
    .footer-icon {
      padding:10px;
    }
  }
  @media (min-width: 421px) {
    .top-bar-background {
      background-image: url('https://storage.googleapis.com/menus-275719.appspot.com/webs/donburi/donburi-main.jpg');
      background-size: cover;
      background-position: bottom;
      background-repeat: no-repeat;
    }


  }
  .navbar-wrapper {
    background-color: rgba(0,0,0,0);
  }
  @media (min-width: 421px) {
    .navbar-wrapper {
      background-color: rgba(0,0,0,0);
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/Home.vue